import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardCheck, faHome, faFileContract } from '@fortawesome/free-solid-svg-icons';
import SmartDocumentChecklist from './SmartDocumentChecklist';

/**
 * Test page for Smart Document Checklist
 * KOPS-174: Document Usage Context Enhancement
 */
const TestSmartChecklist: React.FC = () => {
  const handleDocumentSelect = (documentId: string) => {
    console.log('Document selected:', documentId);
    alert(`Selected document: ${documentId}`);
  };

  return (
    <Container fluid className="py-4">
      <Row className="mb-4">
        <Col>
          <Card className="border-0" style={{
            background: 'linear-gradient(135deg, rgba(0, 212, 255, 0.1) 0%, rgba(14, 165, 233, 0.1) 100%)',
            borderRadius: '16px',
            padding: '24px'
          }}>
            <div className="d-flex align-items-center">
              <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{ 
                width: "56px", 
                height: "56px",
                background: 'linear-gradient(135deg, #00d4ff 0%, #0ea5e9 100%)',
                boxShadow: '0 0 20px rgba(0, 212, 255, 0.5)'
              }}>
                <FontAwesomeIcon icon={faClipboardCheck} className="text-white" size="lg" />
              </div>
              <div>
                <h1 className="mb-0" style={{ color: '#1f2937', fontWeight: 600 }}>
                  Smart Document Checklist Demo
                </h1>
                <p className="mb-0 text-muted">
                  Test the intelligent document requirement system
                </p>
              </div>
            </div>
          </Card>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col md={8} className="mx-auto">
          <Card className="border-0" style={{
            background: 'rgba(255, 255, 255, 0.95)',
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
          }}>
            <Card.Body className="p-4">
              <div className="d-flex align-items-center mb-4">
                <FontAwesomeIcon icon={faHome} className="me-2" style={{ color: '#00d4ff' }} />
                <h5 className="mb-0">Property & Transaction Details</h5>
              </div>
              
              <p className="text-muted mb-4">
                Adjust the property and transaction details below to see how the required documents change dynamically.
                Try different combinations like:
              </p>
              
              <ul className="text-muted">
                <li>Set year built to 1975 to trigger Lead Paint Disclosure</li>
                <li>Enable HOA to require HOA documentation</li>
                <li>Change loan type to FHA/VA for specific amendments</li>
                <li>Toggle pool, septic, or well water for additional disclosures</li>
              </ul>

              <hr className="my-4" />

              <SmartDocumentChecklist 
                onDocumentSelect={handleDocumentSelect}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col md={8} className="mx-auto">
          <Card className="border-0" style={{
            background: 'rgba(0, 212, 255, 0.05)',
            borderRadius: '12px',
            border: '1px solid rgba(0, 212, 255, 0.2)'
          }}>
            <Card.Body>
              <div className="d-flex align-items-center mb-3">
                <FontAwesomeIcon icon={faFileContract} className="me-2" style={{ color: '#0891b2' }} />
                <h6 className="mb-0">How It Works</h6>
              </div>
              <p className="mb-2 small text-muted">
                This smart checklist uses conditional logic to determine which documents are required based on:
              </p>
              <Row>
                <Col md={6}>
                  <ul className="small text-muted mb-0">
                    <li>Property age (for lead paint disclosures)</li>
                    <li>Property features (pool, septic, well)</li>
                    <li>HOA membership status</li>
                    <li>Flood zone designation</li>
                  </ul>
                </Col>
                <Col md={6}>
                  <ul className="small text-muted mb-0">
                    <li>Loan type (FHA, VA, conventional)</li>
                    <li>Solar panel ownership</li>
                    <li>Property type (residential, condo, etc.)</li>
                    <li>Transaction type</li>
                  </ul>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default TestSmartChecklist;